export class DateUtils {

  /**
   * Converts any valid date value to yyyy-MM-dd
   * Suitable for:
   * <input type="date">
   */
  static toDateInputValue(
    value: any
  ): string | null {

    if (!value) {
      return null;
    }

    try {

      const date =
        new Date(value);

      if (
        isNaN(
          date.getTime()
        )
      ) {
        return null;
      }

      const year =
        date.getFullYear();

      const month =
        String(
          date.getMonth() + 1
        ).padStart(2, '0');

      const day =
        String(
          date.getDate()
        ).padStart(2, '0');

      return `${year}-${month}-${day}`;

    }
    catch {

      return null;
    }
  }

  /**
   * Converts any valid date value to MM/dd/yyyy
   * Suitable for:
   * Labels, Grids, Reports
   */
  static toDisplayDate(
    value: any
  ): string {

    if (!value) {
      return '';
    }

    try {

      const date =
        new Date(value);

      if (
        isNaN(
          date.getTime()
        )
      ) {
        return '';
      }

      const month =
        String(
          date.getMonth() + 1
        ).padStart(2, '0');

      const day =
        String(
          date.getDate()
        ).padStart(2, '0');

      const year =
        date.getFullYear();

      return `${month}/${day}/${year}`;

    }
    catch {

      return '';
    }
  }

  /**
   * Converts any valid date value to ISO string
   * Suitable for API payloads
   */
  static toIsoDate(
    value: any
  ): string | null {

    if (!value) {
      return null;
    }

    try {

      const date =
        new Date(value);

      if (
        isNaN(
          date.getTime()
        )
      ) {
        return null;
      }

      return date.toISOString();

    }
    catch {

      return null;
    }
  }

  /**
   * Converts any valid date value to Date object
   * Suitable for Angular Material DatePicker
   */
  static toDate(
    value: any
  ): Date | null {

    if (!value) {
      return null;
    }

    try {

      const date =
        new Date(value);

      return isNaN(
        date.getTime()
      )
        ? null
        : date;

    }
    catch {

      return null;
    }
  }

  /**
   * Returns current date in yyyy-MM-dd format
   */
  static today(): string {

    return this.toDateInputValue(
      new Date()
    )!;
  }
}